export const GET_ALLOW_CLIENTS = `
    query {
        listClientAllow {
            message
            result
            clients_content {
                id_clientInternal
                full_name
                phoneNumber
                email
                loginMethod
                photo
                city_name
            }
        }
    }
`;

export const FILTER_CLIENTS = `
    query($requestSearchData: JSON) { 
    filterSearchclient(requestSearchData: $requestSearchData) { 
        message 
        result 
        clients_content { 
            id_clientInternal 
            full_name 
            phoneNumber 
            email 
            loginMethod 
            photo 
            city_name 
        } 
    } 
    }
`;

export const GET_ID_CLIENT_DATA = `
    query($id:String){
        getClientId(id:$id){
            message
            client_int {
                id
                firstName
                lastName
                email
                phoneNumber
                photo
                status
                nameClient
            }
        }
    }
`;